import axios from 'axios'
import vm from '~/main'

export default {
  namespaced: true,
  state: {
    chatMessageEdit: null,
    chatSelectedMessages: [],
  },
  mutations: {
    SET_updateMessage(state, response) {
      const chatsList = vm.$store.state.chat.chatsList
      const findChatIndex = chatsList.findIndex((i) => i.id === response.chat.id)
      const findMessageIndex =
        findChatIndex > -1 &&
        chatsList[findChatIndex].messages.findIndex((i) => i.id === response.message.id)
      if (findMessageIndex > -1) {
        vm.$set(chatsList[findChatIndex].messages, findMessageIndex, response.message)
      }
    },
    SET_chatMessageEdit(state, payload) {
      // console.log('SET_chatMessageEdit')
      state.chatMessageEdit = payload
    },
    SET_messageStatus(state, { data, status }) {
      // console.log('SET_messageStatus', status)
      const findChat = vm.$store.state.chat.chatsList.find((i) => i.id === data.chatId)
      if (findChat) {
        let findMessage = findChat.messages.find((i) => i.status && i.content === data.content)
        if (findMessage) {
          vm.$set(findMessage, 'status', status)
        }
      }
    },
    SET_chatSelectedMessages(state, { action = 'add', data, index }) {
      switch (action) {
        case 'add':
          state.chatSelectedMessages.push(data)
          break
        case 'remove':
          vm.$delete(state.chatSelectedMessages, index)
          break
        case 'clear':
          state.chatSelectedMessages = []
      }
    },
    SET_readMessage(state, { chatId, messageIds }) {
      const currentChat = vm.$store.state.chat.chatsList.find((i) => i.id === chatId)
      for (let messageId of messageIds) {
        let message = currentChat.messages.find((i) => i.id === messageId)
        if (message && !message.isSeen) {
          message.isSeen = true
        }
      }
    },
    SET_countUnseen(state, { chatId, count }) {
      const findChat = vm.$store.state.chat.chatsList.find((i) => i.id === chatId)
      const _count = { messages: Number(findChat?._count?.messages) + count }
      vm.$set(findChat, '_count', _count)
    },
    SET_chatAdditionalMessageById(state, { data, chatId, order }) {
      let chatObj =
        vm.$store.state.chat.chatsList[
          vm.$store.state.chat.chatsList.findIndex((i) => i.id === chatId)
        ]
      data = data.sort((a, b) => {
        return a.id - b.id
      })
      if (data.length) {
        vm.$set(
          chatObj,
          'messages',
          order === 'desc' ? [...data, ...chatObj.messages] : [...chatObj.messages, ...data],
        )
      }
    },
    SET_pushMessage(state, { chat, message, previousMessage }) {
      const findChat = vm.$store.state.chat.chatsList.find((i) => i.id === chat.id)
      if (findChat) {
        const findMessageIndex = findChat.messages.findIndex(
          (i) => i.status && i.content === message.content,
        )
        if (findMessageIndex > -1) {
          // console.log('findMessage before', findChat.messages[findMessageIndex])
          // findChat.messages.splice(findMessageIndex, 1)
          vm.$set(findChat.messages, findMessageIndex, message)
          // console.log('findMessage after', findChat.messages[findMessageIndex])
        } else {
          const readyPreviousMessage =
            findChat.messages.length && findChat.messages[findChat.messages.length - 1]
          // console.log('SET_pushMessage else', { previousMessage, readyPreviousMessage })
          if (
            previousMessage && readyPreviousMessage
              ? readyPreviousMessage.id === previousMessage.id
              : true
          ) {
            findChat.messages.push(message)
          }
        }
        if (vm.$store.getters['user/userData'].id !== message.senderId)
          vm.$store.commit('chat/messages/SET_countUnseen', { chatId: findChat.id, count: 1 })
        vm.$set(findChat, 'lastMessage', message)
        if (message.attachments?.length) {
          vm.$store.commit('chat/SET_chatIdMedia', {
            resp: { data: message.attachments },
            chat: findChat,
            actionType: 'add',
          })
        }
      }
    },
    SET_deleteMessage(state, { chatId, messageId }) {
      const findChat = vm.$store.state.chat.chatsList.find((i) => i.id === chatId)
      // console.log('findChat', findChat)
      const findMessageIndex = findChat?.messages.findIndex((i) => i.id === messageId)
      const findMessage = findChat.messages[findMessageIndex]
      // console.log('findMessageIndex', findMessageIndex)
      if (findMessageIndex > -1) {
        if (findMessage.attachments?.length) {
          vm.$store.commit('chat/SET_chatIdMedia', {
            resp: { data: findMessage.attachments },
            chat: findChat,
            actionType: 'delete',
          })
        }
        vm.$delete(findChat.messages, findMessageIndex)
      }
    },
    SET_messagesClear(state, { chat }) {
      const findChat = vm.$store.state.chat.chatsList.find((i) => i.id === chat.id)
      vm.$set(findChat, 'messages', [])
    },
  },
  getters: {
    chatSelectedMessagesAllFromCurrentUser(state) {
      const currentUser = vm.$store.getters['user/userData']
      return state.chatSelectedMessages.every((i) => i.senderId === currentUser.id)
    },
  },
  actions: {
    GET_chatAdditionalMessageById(
      { rootState, commit, state },
      { chatId, lastMessageId, order, take },
    ) {
      vm.$store.commit('chat/SET_chatIsLoading', true)
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.chatApiDomain +
            '/v1/chat/' +
            chatId +
            '/messages?take=' +
            (take || 15) +
            '&cursor=' +
            lastMessageId +
            '&order=' +
            order,
          method: 'GET',
          headers: rootState.chat.chatAxiosHeaders(),
        })
          .then((resp) => {
            commit('SET_chatAdditionalMessageById', { data: resp.data, chatId, order })
            resolve(resp.data)
          })
          .catch((err) => {
            reject(err)
          })
          .finally(() => {
            vm.$store.commit('chat/SET_chatIsLoading', false)
          })
      })
    },
    SEND_chatMessage(
      { rootState, commit, state, dispatch },
      { data: { content, chatIds, files }, identity },
    ) {
      const data = { content, chatIds, files }
      // console.log('SEND_chatMessage', { data, identity })
      const clearFileUploads = () => {
        if (files && files.length) {
          dispatch('chat/file/CLEAR_chatFileUploads', { identity }, { root: true })
        }
      }
      if ((content !== null && content !== '') || (files && files.length)) {
        let sendData = {
          content,
          chatIds,
        }
        return new Promise(async (resolve, reject) => {
          if (files && files.length) {
            sendData.fileIds = await Promise.all(
              files.map((file, index) => {
                return dispatch(
                  'chat/file/POST_chatFile',
                  { file, index, identity },
                  { root: true },
                )
              }),
            )
          }
          let config = {
            url: rootState.chatApiDomain + '/v1/chat/message',
            method: 'POST',
            data: sendData,
            headers: rootState.chat.chatAxiosHeaders(),
          }
          let attempts = 0
          commit('SET_messageStatus', { data, status: 'waiting' })
          const startAxios = () =>
            axios(config)
              .then((resp) => {
                resolve(resp.data)
                clearFileUploads()
                dispatch('CLEAR_chatSelectedMessages')
              })
              .catch((err) => {
                if (attempts < 2) {
                  attempts++
                  setTimeout(startAxios, 10000)
                } else {
                  clearFileUploads()
                  commit('SET_messageStatus', { data, status: 'error' })
                }
                reject(err)
              })
          startAxios()
        })
      }
    },
    UPDATE_chatMessage(
      { rootState, commit, state, dispatch },
      { data: { content, id, files }, identity },
    ) {
      const clearFileUploads = () => {
        if (files && files.length) {
          dispatch('chat/file/CLEAR_chatFileUploads', { identity }, { root: true })
        }
      }
      return new Promise(async (resolve, reject) => {
        let sendData = { content: content ? content : null, id }
        if (files && files.length) {
          sendData.fileIds = await Promise.all(
            files.map((file, index) => {
              return dispatch('chat/file/POST_chatFile', { file, index, identity }, { root: true })
            }),
          )
        }
        let config = {
          url: rootState.chatApiDomain + '/v1/chat/message/' + id,
          method: 'PUT',
          data: sendData,
          headers: rootState.chat.chatAxiosHeaders(),
        }
        axios(config)
          .then((resp) => {
            // commit('SET_updateMessage', { chat: { id: chatId }, message: resp.data })
            if (state.chatMessageEdit) {
              dispatch('CANCEL_chatMessageEdit')
            }
            resolve(resp.data)
          })
          .catch((err) => {
            reject(err)
          })
          .finally(() => {
            clearFileUploads()
          })
      })
    },
    async FORWARD_chatMessages({ rootState, dispatch }, { messageIds, chatId }) {
      const onForwardMessage = (messageId) => {
        return new Promise((resolve, reject) => {
          let config = {
            url: rootState.chatApiDomain + '/v1/chat/message/forward',
            method: 'POST',
            data: {
              chatId,
              messageId,
            },
            headers: rootState.chat.chatAxiosHeaders(),
          }
          axios(config)
            .then((resp) => {
              resolve(resp)
            })
            .catch((err) => {
              reject(err)
            })
        })
      }
      return await Promise.all(
        messageIds.map((messageId) => {
          onForwardMessage(messageId)
        }),
      )
        .then((resp) => {
          // console.log('resp', resp)
          dispatch('CLEAR_chatSelectedMessages')
        })
        .catch((err) => console.warn('err', err))
    },
    DELETE_chatSelectedMessages({ state, dispatch }) {
      const requests = []
      for (let message of state.chatSelectedMessages) {
        requests.push(dispatch('DELETE_chatMessage', { messageId: message.id }))
      }
      Promise.all(requests)
        .then((resp) => {
          // console.log('complete', resp)
          dispatch('CLEAR_chatSelectedMessages')
        })
        .catch((err) => {
          // console.log('err', err)
        })

      //
    },
    SELECT_chatSelectedMessages({ state, commit }, data = { id, senderId, chatId }) {
      const findIndexMessage = state.chatSelectedMessages.findIndex((e) => e.id === data.id)
      if (findIndexMessage > -1) {
        commit('SET_chatSelectedMessages', { action: 'remove', index: findIndexMessage })
      } else {
        commit('SET_chatSelectedMessages', { action: 'add', data })
      }
    },
    CLEAR_chatSelectedMessages({ commit }) {
      commit('SET_chatSelectedMessages', { action: 'clear' })
    },
    SELECT_chatMessageEdit({ commit }, message) {
      commit('SET_chatMessageEdit', message)
      if (message.attachments.length) {
        // console.log('message.attachments', message.attachments)
        let filesList = []
        for (let file of message.attachments) {
          filesList.push(file.file ? file.file : file)
        }
        // console.log('filesList', filesList)
        vm.$store.dispatch('chat/file/ADD_chatFileSelect', {
          filesList,
        })
      }
    },
    CANCEL_chatMessageEdit({ commit }) {
      commit('SET_chatMessageEdit', null)
    },
    DELETE_chatMessage({ rootState, commit, state }, { messageId }) {
      return new Promise((resolve, reject) => {
        let config = {
          url: rootState.chatApiDomain + '/v1/chat/message/' + messageId,
          method: 'DELETE',
          headers: rootState.chat.chatAxiosHeaders(),
        }
        axios(config)
          .then((resp) => {
            // console.log('DELETE_chatMessage', resp)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    DELETE_chatMessagesClear({ rootState, state }, { chatId }) {
      return new Promise((resolve, reject) => {
        let config = {
          url: rootState.chatApiDomain + '/v1/chat/' + chatId + '/messages',
          method: 'DELETE',
          headers: rootState.chat.chatAxiosHeaders(),
        }
        axios(config)
          .then((resp) => {
            // console.log('DELETE_chatMessagesClear', resp)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    READ_chatMessages({ rootState, state }, { messageIds, chatId }) {
      return new Promise((resolve, reject) => {
        let config = {
          url: rootState.chatApiDomain + '/v1/chat/' + chatId + '/read',
          method: 'PUT',
          data: {
            messageIds,
          },
          headers: rootState.chat.chatAxiosHeaders(),
        }
        axios(config)
          .then((resp) => {
            // console.log('READ_chatMessages', resp)
            resolve(resp.data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
